<!-- Modern Medical Header Component -->
<!-- Modern Medical Header Component - Mobile Optimized -->
<header class="medical-header w-full topbar">
    <nav class="navbar navbar-expand-lg navbar-dark px-2 px-sm-3 px-lg-4">
        <div class="container-fluid">
            <!-- Enhanced Logo Section -->
            <div class="navbar-brand-wrapper d-flex align-items-center">
                <button class="sidebar-toggle btn btn-link text-white d-lg-none me-2" (click)="collapse()"
                    aria-label="Toggle sidebar">
                    <i class="fas fa-bars fs-6 fs-sm-5"></i>
                </button>

                <a class="navbar-brand d-flex align-items-center text-decoration-none" href="javascript:void(0)">
                    <div class="logo-container me-2">
                        <img src="../assets/logo.png" alt="MedFest Logo" class="logo-img">
                    </div>
                    <div class="brand-text" *ngIf="isCollapse">
                        <span class="brand-name">Med</span>
                        <span class="brand-accent">Fest</span>
                        <div class="brand-tagline d-none d-sm-block">Healthcare Platform</div>
                    </div>
                </a>
            </div>

            <!-- Desktop Sidebar Toggle -->
            <button class="sidebar-toggle btn btn-link text-white d-none d-lg-block me-3" (click)="collapse()"
                aria-label="Toggle sidebar">
                <i class="fas fa-bars fs-5"></i>
            </button>

            <!-- Enhanced Search Section - Mobile Optimized -->
            <div class="search-section flex-grow-1 mx-2 mx-sm-3 mx-lg-4 d-none d-md-block">
                <div class="search-container position-relative" ngbDropdown>
                    <div class="input-group">
                        <span class="input-group-text bg-transparent border-0">
                            <i class="fas fa-search text-white-50"></i>
                        </span>
                        <input type="text" class="form-control search-input" ngbDropdownToggle (focus)="searchUser()"
                            (keyup)="searchUser()" placeholder="Search patients, doctors, or records..."
                            [(ngModel)]="userSearchQuery">
                    </div>
                    <div class="dropdown-menu search-dropdown w-100" ngbDropdownMenu
                        *ngIf="users.length > 0 && userSearchQuery !== ''">
                        <div class="search-results">
                            <a class="dropdown-item search-item" (click)="selectUser(item)" ngbDropdownItem
                                *ngFor="let item of users">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-user-circle me-2 text-primary"></i>
                                    <div>
                                        <div class="fw-semibold">{{item.username}}</div>
                                        <small class="text-muted">{{item.name}}</small>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

           
            <!-- Enhanced Navigation Actions -->
            <div class="navbar-nav d-flex flex-row align-items-center">
                <!-- Notifications with Modern Design -->
                <div class="nav-item dropdown me-1 me-sm-2" ngbDropdown [autoClose]="true">
                    <button class="nav-btn notification-btn" ngbDropdownToggle aria-label="Notifications">
                        <i class="fas fa-bell"></i>
                        <span *ngIf="isUnreadNotifiocation()" class="notification-badge">
                            <span class="badge-pulse"></span>
                        </span>
                    </button>

                    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end notification-dropdown">
                        <div class="dropdown-header d-flex justify-content-between align-items-center">
                            <h6 class="mb-0">Notifications</h6>
                            <span class="badge bg-primary rounded-pill">{{userNotifications?.length || 0}}</span>
                        </div>

                        <div class="notification-list">
                            <div *ngIf="userNotifications?.length === 0" class="no-notifications">
                                <i class="fas fa-bell-slash text-muted"></i>
                                <p class="mb-0">No new notifications</p>
                            </div>

                            <div *ngIf="userNotifications?.length > 0" class="notifications-content">
                                <a *ngFor="let noti of userNotifications"
                                    (click)="goToNotification(noti?._id, noti?.category, noti?.naviagteUrl)"
                                    href="javascript:void(0)" class="notification-item">

                                    <div class="notification-avatar">
                                        <img *ngIf="noti?.category === 6" src="../../assets/images/users/user.jpg"
                                            alt="Hospital" class="avatar-img">
                                        <img *ngIf="noti?.category !== 6" [src]="noti?.createdBy?.image | imageSrc"
                                            alt="User" class="avatar-img">
                                        <div class="status-indicator bg-success"></div>
                                    </div>

                                    <div class="notification-content">
                                        <div class="notification-title">
                                            {{noti?.category === 6 ? 'Hospital Request' : noti?.createdBy?.name}}
                                        </div>
                                        <div class="notification-desc">{{noti?.description}}</div>
                                        <div class="notification-time">
                                            {{(noti?.category === 6 ? noti?.date : noti?.createdAt) | date:'short'}}
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Messages with Modern Design -->
                <div *ngIf="showMessagesButton()" class="nav-item dropdown me-1 me-sm-2" ngbDropdown>
                    <button class="nav-btn message-btn" ngbDropdownToggle aria-label="Messages">
                        <i class="fas fa-comment-dots"></i>
                        <span *ngIf="isUnreadMessage()" class="notification-badge">
                            <span class="badge-pulse"></span>
                        </span>
                    </button>

                    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end message-dropdown">
                        <div class="dropdown-header">
                            <h6 class="mb-0">Messages</h6>
                        </div>

                        <div class="message-list">
                            <div *ngIf="userMessages?.length === 0" class="no-messages">
                                <i class="fas fa-comment-slash text-muted"></i>
                                <p class="mb-0">No new messages</p>
                            </div>

                            <div *ngIf="userMessages?.length > 0" class="messages-content">
                                <a *ngFor="let msg of userMessages" (click)="markReadMessage(msg?._id); gotoChat()"
                                    href="javascript:void(0)" class="message-item">

                                    <div class="message-avatar">
                                        <img [src]="msg?.createdBy?.image | imageSrc" alt="User" class="avatar-img">
                                        <div class="status-indicator bg-success"></div>
                                    </div>

                                    <div class="message-content">
                                        <div class="message-sender">{{msg?.createdBy?.name}}</div>
                                        <div class="message-text">{{msg?.message}}</div>
                                        <div class="message-time">{{msg?.date | date:'short'}}</div>
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div class="dropdown-footer">
                            <a (click)="gotoChat()" href="javascript:void(0)" class="btn btn-sm btn-primary w-100">
                                View All Messages
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Enhanced User Profile -->
                <div class="nav-item dropdown user-dropdown" ngbDropdown>
                    <button class="user-profile-btn d-flex align-items-center" ngbDropdownToggle aria-label="User menu">
                        <div class="user-avatar me-2">
                            <img [src]="imageSrc" alt="User" class="avatar-img">
                            <div class="status-indicator bg-success"></div>
                        </div>
                        <div class="user-info d-none d-lg-block">
                            <div class="user-name">{{user.name}}</div>
                            <div class="user-role">Healthcare Professional</div>
                        </div>
                        <i class="fas fa-chevron-down ms-2 d-none d-lg-inline"></i>
                    </button>

                    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end user-menu">
                        <div class="dropdown-header user-header">
                            <div class="d-flex align-items-center">
                                <img [src]="imageSrc" alt="User" class="user-avatar-large me-3">
                                <div>
                                    <div class="fw-semibold">{{user.name}}</div>
                                    <small class="text-muted">Healthcare Professional</small>
                                </div>
                            </div>
                        </div>

                        <div class="dropdown-divider"></div>

                        <a href="javascript:void(0)" (click)="goToProfile()" class="dropdown-item menu-item">
                            <i class="fas fa-user-circle me-2"></i>
                            My Profile
                        </a>

                        <a href="javascript:void(0)" class="dropdown-item menu-item">
                            <i class="fas fa-cog me-2"></i>
                            Settings
                        </a>

                        <div class="dropdown-divider"></div>

                        <a href="javascript:void(0)" class="dropdown-item menu-item text-danger" (click)="logout()">
                            <i class="fas fa-sign-out-alt me-2"></i>
                            Logout
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </nav>

    <!-- Mobile Search Overlay -->
    <div class="mobile-search-overlay" >
        <div class="mobile-search-container" (click)="$event.stopPropagation()">
            <div class="mobile-search-header">
                <h6 class="mb-0 text-white">Search</h6>
                <button class="btn btn-link text-white p-0"  aria-label="Close search">
                    <i class="fas fa-times"></i>
                </button>
            </div>
            <div class="mobile-search-content">
                <div class="search-container position-relative" ngbDropdown>
                    <div class="input-group">
                        <span class="input-group-text bg-transparent border-0">
                            <i class="fas fa-search text-white-50"></i>
                        </span>
                        <input type="text" class="form-control search-input" ngbDropdownToggle (focus)="searchUser()"
                            (keyup)="searchUser()" placeholder="Search patients, doctors, or records..."
                            [(ngModel)]="userSearchQuery" #mobileSearchInput>
                    </div>
                    <div class="dropdown-menu search-dropdown w-100" ngbDropdownMenu
                        *ngIf="users.length > 0 && userSearchQuery !== ''">
                        <div class="search-results">
                            <a class="dropdown-item search-item" (click)="selectUser(item);" 
                                ngbDropdownItem *ngFor="let item of users">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-user-circle me-2 text-primary"></i>
                                    <div>
                                        <div class="fw-semibold">{{item.username}}</div>
                                        <small class="text-muted">{{item.name}}</small>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>

<!-- Enhanced CSS Styles -->
<style>
    .medical-header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        backdrop-filter: blur(10px);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .navbar-brand-wrapper {
        min-width: 200px;
    }

    .logo-container {
        width: 45px;
        height: 45px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(10px);
    }

    .logo-img {
        width: 32px;
        height: 32px;
        object-fit: contain;
    }

    .brand-text {
        line-height: 1.2;
    }

    .brand-name {
        font-size: 1.5rem;
        font-weight: 700;
        color: white;
    }

    .brand-accent {
        font-size: 1.5rem;
        font-weight: 700;
        color: #ffd700;
    }

    .brand-tagline {
        font-size: 0.7rem;
        color: rgba(255, 255, 255, 0.7);
        font-weight: 500;
        margin-top: -2px;
    }

    .sidebar-toggle {
        color: white !important;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
    }

    .sidebar-toggle:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: translateY(-1px);
    }

    .search-container {
        max-width: 500px;
    }

    .search-input {
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        color: white;
        border-radius: 25px;
        padding: 12px 20px;
        font-size: 0.9rem;
        transition: all 0.3s ease;
    }

    .search-input:focus {
        background: rgba(255, 255, 255, 0.15);
        border-color: rgba(255, 255, 255, 0.4);
        box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);
        color: white;
    }

    .search-input::placeholder {
        color: rgba(255, 255, 255, 0.6);
    }

    .input-group-text {
        background: transparent;
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-right: none;
        border-radius: 25px 0 0 25px;
    }

    .search-dropdown {
        border: none;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        border-radius: 12px;
        overflow: hidden;
        margin-top: 8px;
    }

    .search-item {
        padding: 12px 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        transition: all 0.2s ease;
    }

    .search-item:hover {
        background: rgba(102, 126, 234, 0.1);
    }

    .nav-btn {
        background: rgba(255, 255, 255, 0.1);
        border: none;
        color: white;
        width: 45px;
        height: 45px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        transition: all 0.3s ease;
        font-size: 1.1rem;
    }

    .nav-btn:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: translateY(-2px);
        color: white;
    }

    .notification-badge {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 12px;
        height: 12px;
        background: #ff4757;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .badge-pulse {
        width: 100%;
        height: 100%;
        background: #ff4757;
        border-radius: 50%;
        animation: pulse 2s infinite;
    }

    @keyframes pulse {
        0% {
            transform: scale(1);
            opacity: 1;
        }

        50% {
            transform: scale(1.3);
            opacity: 0.7;
        }

        100% {
            transform: scale(1);
            opacity: 1;
        }
    }

    .user-profile-btn {
        background: rgba(255, 255, 255, 0.1);
        border: none;
        color: white;
        padding: 8px 12px;
        border-radius: 25px;
        transition: all 0.3s ease;
        text-decoration: none;
    }

    .user-profile-btn:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: translateY(-1px);
        color: white;
    }

    .user-avatar {
        width: 35px;
        height: 35px;
        position: relative;
    }

    .user-avatar-large {
        width: 45px;
        height: 45px;
    }

    .avatar-img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid rgba(255, 255, 255, 0.2);
    }

    .status-indicator {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 2px solid white;
    }

    .user-info {
        text-align: left;
    }

    .user-name {
        font-size: 0.9rem;
        font-weight: 600;
        line-height: 1.2;
        color: white;
    }

    .user-role {
        font-size: 0.75rem;
        color: rgba(255, 255, 255, 0.7);
        line-height: 1.2;
    }

    .notification-dropdown,
    .message-dropdown,
    .user-menu {
        border: none;
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
        border-radius: 16px;
        overflow: hidden;
        min-width: 320px;
        margin-top: 8px;
    }

    .dropdown-header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        padding: 16px 20px;
        border-bottom: none;
        font-weight: 600;
    }

    .user-header {
        padding: 20px;
    }

    .notification-list,
    .message-list {
        max-height: 400px;
        overflow-y: auto;
    }

    .no-notifications,
    .no-messages {
        text-align: center;
        padding: 40px 20px;
        color: #6c757d;
    }

    .notification-item,
    .message-item {
        display: flex;
        align-items: center;
        padding: 16px 20px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        text-decoration: none;
        color: inherit;
        transition: all 0.2s ease;
    }

    .notification-item:hover,
    .message-item:hover {
        background: rgba(102, 126, 234, 0.05);
        color: inherit;
    }

    .notification-avatar,
    .message-avatar {
        width: 45px;
        height: 45px;
        position: relative;
        margin-right: 12px;
        flex-shrink: 0;
    }

    .notification-content,
    .message-content {
        flex: 1;
        min-width: 0;
    }

    .notification-title,
    .message-sender {
        font-weight: 600;
        font-size: 0.9rem;
        color: #333;
        margin-bottom: 4px;
    }

    .notification-desc,
    .message-text {
        font-size: 0.8rem;
        color: #666;
        line-height: 1.4;
        margin-bottom: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .notification-time,
    .message-time {
        font-size: 0.75rem;
        color: #999;
    }

    .dropdown-footer {
        padding: 16px 20px;
        background: rgba(0, 0, 0, 0.02);
        border-top: 1px solid rgba(0, 0, 0, 0.05);
    }

    .menu-item {
        display: flex;
        align-items: center;
        padding: 12px 20px;
        font-size: 0.9rem;
        transition: all 0.2s ease;
        text-decoration: none;
    }

    .menu-item:hover {
        background: rgba(102, 126, 234, 0.1);
        color: #667eea;
    }

    .menu-item.text-danger:hover {
        background: rgba(220, 53, 69, 0.1);
        color: #dc3545;
    }

    .menu-item i {
        width: 20px;
        text-align: center;
    }


        /* Mobile Search Overlay */
        .mobile-search-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 1050;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s ease;
    }

    .mobile-search-overlay.active {
        opacity: 1;
        visibility: visible;
    }

    .mobile-search-container {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        margin: 0;
        height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .mobile-search-header {
        display: flex;
        justify-content: between;
        align-items: center;
        padding: 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .mobile-search-content {
        padding: 20px;
        flex: 1;
    }

    /* Enhanced Mobile Styles */
    @media (max-width: 767.98px) {
        .medical-header .container-fluid {
            padding: 0 8px;
        }

        .navbar-brand-wrapper {
            min-width: 120px;
        }

        .logo-container {
            width: 35px;
            height: 35px;
            border-radius: 8px;
        }

        .logo-img {
            width: 24px;
            height: 24px;
        }

        .brand-name,
        .brand-accent {
            font-size: 1.1rem;
        }

        .brand-tagline {
            font-size: 0.6rem;
        }

        .sidebar-toggle {
            width: 32px;
            height: 32px;
        }

        .nav-btn {
            width: 35px;
            height: 35px;
            font-size: 0.9rem;
            border-radius: 8px;
        }

        .user-avatar {
            width: 28px;
            height: 28px;
        }

        .user-profile-btn {
            padding: 4px 8px;
            border-radius: 16px;
        }

        .notification-dropdown,
        .message-dropdown,
        .user-menu {
            min-width: 260px;
            right: 0 !important;
            left: auto !important;
            transform: translateX(0) !important;
        }

        .notification-badge {
            top: 4px;
            right: 4px;
            width: 8px;
            height: 8px;
        }

        .status-indicator {
            width: 8px;
            height: 8px;
            border-width: 1px;
        }
    }

    @media (max-width: 575.98px) {
        .medical-header .container-fluid {
            padding: 0 6px;
        }

        .navbar-brand-wrapper {
            min-width: 100px;
        }

        .logo-container {
            width: 32px;
            height: 32px;
        }

        .logo-img {
            width: 22px;
            height: 22px;
        }

        .brand-name,
        .brand-accent {
            font-size: 1rem;
        }

        .sidebar-toggle {
            width: 30px;
            height: 30px;
        }

        .nav-btn {
            width: 32px;
            height: 32px;
            font-size: 0.85rem;
        }

        .user-avatar {
            width: 26px;
            height: 26px;
        }

        .user-profile-btn {
            padding: 3px 6px;
        }

        .notification-dropdown,
        .message-dropdown,
        .user-menu {
            min-width: 240px;
            margin-top: 4px;
        }

        .dropdown-header {
            padding: 12px 14px;
        }

        .notification-item,
        .message-item {
            padding: 10px 14px;
        }

        .notification-avatar,
        .message-avatar {
            width: 35px;
            height: 35px;
        }

        .menu-item {
            padding: 8px 14px;
            font-size: 0.8rem;
        }
    }

    /* Ultra Small Screens */
    @media (max-width: 374px) {
        .medical-header .container-fluid {
            padding: 0 4px;
        }

        .navbar-brand-wrapper {
            min-width: 80px;
        }

        .brand-text {
            display: none;
        }

        .nav-btn {
            width: 30px;
            height: 30px;
            margin: 0 1px;
        }

        .notification-dropdown,
        .message-dropdown,
        .user-menu {
            min-width: 220px;
            right: -10px !important;
        }
    }

    /* Landscape Mobile Optimization */
    @media (max-height: 500px) and (orientation: landscape) {
        .notification-list,
        .message-list {
            max-height: 250px;
        }

        .mobile-search-container {
            padding-top: 10px;
        }

        .mobile-search-header {
            padding: 15px 20px;
        }

        .mobile-search-content {
            padding: 15px 20px;
        }
    }

    /* Touch Friendly Improvements */
    @media (hover: none) and (pointer: coarse) {
        .nav-btn,
        .sidebar-toggle,
        .user-profile-btn {
            min-height: 44px;
            min-width: 44px;
        }

        .notification-item,
        .message-item,
        .menu-item {
            min-height: 48px;
            padding: 12px 16px;
        }
    }

    /* Dark mode support for mobile */
    @media (prefers-color-scheme: dark) {
        .search-dropdown,
        .notification-dropdown,
        .message-dropdown,
        .user-menu {
            background: #2c3e50;
            color: white;
        }

        .dropdown-item {
            color: rgba(255, 255, 255, 0.9);
        }

        .dropdown-item:hover {
            background: rgba(52, 152, 219, 0.2);
            color: white;
        }
    }

    /* Responsive Design */
    @media (max-width: 768px) {
        .search-section {
            margin: 0 8px;
        }

        .search-input {
            font-size: 0.85rem;
            padding: 10px 16px;
        }

        .notification-dropdown,
        .message-dropdown,
        .user-menu {
            min-width: 280px;
            margin-top: 4px;
        }

        .nav-btn {
            width: 40px;
            height: 40px;
            font-size: 1rem;
        }

        .brand-name,
        .brand-accent {
            font-size: 1.25rem;
        }
    }

    @media (max-width: 576px) {
        .medical-header .container-fluid {
            padding: 0 12px;
        }

        .search-section {
            margin: 0 4px;
        }

        .notification-dropdown,
        .message-dropdown,
        .user-menu {
            min-width: 250px;
            right: -20px !important;
        }
    }

</style>
